import { render } from "./MenuItemLayout.vue?vue&type=template&id=47eb3c7d&scoped=true&ts=true"
import script from "./MenuItemLayout.vue?vue&type=script&lang=ts"
export * from "./MenuItemLayout.vue?vue&type=script&lang=ts"

import "./MenuItemLayout.vue?vue&type=style&index=0&id=47eb3c7d&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47eb3c7d"]])

export default __exports__